import { IObjectTranslatable, RelationalActionTranslator, RelationalActionExtractor } from ".";
import { IImageItemBean, ITypeDefinable } from "../beans/items";
import { IItem, ImageItem } from "../../../../domain/document/items";
import { ImageSource } from "..";
import {
  Point,
  Rectangle,
  Size,
} from "../../../../domain/drawing";

export abstract class AbstractImageItemTranslator<TItem extends ImageItem, TBean extends IImageItemBean> implements IObjectTranslatable {
  constructor(protected _getToken: () => string, private readonly _beanType: string) {}

  protected abstract craeteItem(): TItem;

  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as TBean;
    const result = this.craeteItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.name = bean.name;
    result.isEditable = bean.imageEditable;
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.imageSource = new ImageSource(this._getToken, formatId, documentId, bean.imageStoragePlace, bean.imageGuid);
    result.originalImageSource = new ImageSource(this._getToken, formatId, documentId, bean.originalImageStoragePlace, bean.originalImageGuid);
    result.drawLayerImageSource = new ImageSource(this._getToken, formatId, documentId, bean.drawLayerImageStoragePlace, bean.drawLayerImageGuid);
    result.drawObjectData = (bean.drawObjectData != null) ? bean.drawObjectData : null;
    result.imageKind = bean.imageType;
    result.claioImageId = (bean.claioImageKey != null) ? bean.claioImageKey.toString() : null;
    result.shouldQuote = !!bean.isQuotable;
    result.supportedQuotable = !!bean.supportedQuotable;
    result.rotationAngle = bean.rotationAngle;
    result.imageDepartmentId = bean.imageDepartmentCode;
    result.externalImageId = bean.externalImageKey;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.scriptExecuteParameters = RelationalActionExtractor.extractScriptExecuteParameters(result.actions);
    return result;
  }

  toBean(item: IItem): IImageItemBean {
    const target = item as TItem;
    return {
      type: this._beanType,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      name: target.name,
      imageEditable: target.isEditable,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      imageStoragePlace: target.imageSource.imageSourceKind,
      imageGuid: target.imageSource.imageGuid,
      imageQuotedformatId: target.imageSource.quotedFormatId,
      imageType: target.imageKind,
      claioImageKey: target.claioImageId ? parseInt(target.claioImageId, 10) : null,
      isQuotable: target.shouldQuote,
      supportedQuotable: target.supportedQuotable,
      rotationAngle: target.rotationAngle ? target.rotationAngle : 0,
      imageDepartmentCode: target.imageDepartmentId,
      relationalItems: null, // TODO:返却する必要ある？
      externalImageKey: target.externalImageId,
      originalImageStoragePlace: target.originalImageSource.imageSourceKind,
      originalImageGuid: target.originalImageSource.imageGuid,
      drawLayerImageStoragePlace: target.drawLayerImageSource.imageSourceKind,
      drawLayerImageGuid: target.drawLayerImageSource.imageGuid,
      drawObjectData: target.drawObjectData,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
    };
  }
}
